import React from 'react'
import { BaseSvgIcon, BaseSvgIconProps } from './base-svg-icon'

export const UserCheckIcon = ({
  className,
  color,
  size,
  title,
  ...rest
}: BaseSvgIconProps) => {
  return (
    <BaseSvgIcon
      className={className}
      fill="none"
      size={size}
      viewBox="0 0 16 16"
      {...rest}>
      {title && <title>{title}</title>}
      <path
        d="M10.666 14v-1.333A2.667 2.667 0 007.999 10H3.333a2.667 2.667 0 00-2.667 2.667V14M5.667 7.333a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zM11.334 7.333l1.333 1.334L15.334 6"
        stroke={color || 'currentColor'}
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSvgIcon>
  )
}
